module.exports = __webpack_public_path__ + "media/images/sections/home/grrom_gr-78e0c4b125c422ee46aa4c105f0ed4ec.png";